import {Injectable} from '@angular/core';

export const DemoUserID = '102507';

@Injectable()
export class DemoService {
    isDemoUser = false;

    get isDemoHost() {
        return location.host === 'demo.appodeal.com';
    }

    get isAccountDemoOnly() {
        return this.isDemoUser && !this.isDemoHost;
    }
}
